import http from '../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_SENSPRO}`

const apiInfoDispositivos = (query) => http.get(`${api}/reports/dispositivos`, { params: { ...query } })

export {
  apiInfoDispositivos
}
